import wrapRoot from "./common/wrapRoot"

// Wraps every page in a component
export const wrapRootElement = wrapRoot
